module.exports = __webpack_public_path__ + "static/media/1274_CareTeam_bio9.a8106b03.png";